import { ReactElement, useState } from "react";
import { T } from "react-translator-component";
import {
  Button, Dialog, DialogContent,
  DialogTitle, Typography
} from "@mui/material";
import cancel from "../../assets/images/cancel.png";
import checkicon from "../../assets/images/checkicon.png";
import deleteicon from "../../assets/images/deleteicon.png";
import SubmitButton from "../../../components/SubmitButton";
import { colors } from "../../../common/colors";

interface Props {
  show: boolean;
  isApprove: boolean;
  onSubmit: () => Promise<boolean>;
  onClose: () => void;
}

export default function ConfirmModal({show, isApprove, onSubmit, onClose}: Props): ReactElement {
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false)

  const handleSubmit = async () => {
    setBtnDisabled(true)
    const result = await onSubmit()
    setBtnDisabled(result)
    return result
  }

  return (
    <Dialog open={show} onClose={onClose}>
      <img
        src={cancel}
        onClick={onClose}
        style={styles.closeImg}
      />

      <img src={isApprove ? checkicon : deleteicon} style={styles.icon} />

      <Typography sx={styles.message}>
        {T("mng_dialog_confirmation_title")}
      </Typography>

      <DialogTitle
        sx={{
          ...styles.title,
          color: isApprove ? colors.farm_green500 : colors.farm_red600,
        }}
      >
        {isApprove ? T("mng_confirm_approve") : T("mng_confirm_reject")}
      </DialogTitle>

      <DialogContent>
        <div style={styles.btnBox}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={styles.cancelBtn}
            disabled={btnDisabled}
          >
            {T("mng_cancel")}
          </Button>

          <SubmitButton
            onSubmit={handleSubmit}
            variant="contained"
            color={isApprove ? "success" : "error"}
            sx={{ textAlign: "center", alignItems: "center" }}
            validate={async () => true}
          >
            {isApprove ? T("mng_approve") : T("mng_reject")}
          </SubmitButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const styles = {
  closeImg: {
    width: 30,
    height: 30,
    alignSelf: "flex-end",
    marginRight: 10,
    marginTop: 10,
  },
  icon: {
    width: 100,
    height: 100,
    alignSelf: "center",
    color: colors.farm_red600,
  },
  message: {
    textAlign: "center",
    fontSize: 30,
    marginTop: 2,
    marginBottom: 2,
    height: 20,
  },
  title: {
    fontWeight: "400",
    textAlign: "center",
  },
  btnBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 0
  },
  cancelBtn: {
    textAlign: "center",
    backgroundColor: "gray",
    marginRight: 5,
  },
  submit: {
    textAlign: "center",
    alignItems: "center"
  }
}